export const princegeorgeTheme = {
  colors: {
    primary: 'rgba(0, 58, 120, 1)',
    primaryLight: 'rgba(178, 196, 214, 1)',
    primaryExtraLight: 'rgba(217, 225, 235, 1)',
    error: '#E84C3D',
    errorLight: 'rgba(232, 76, 61, 0.15)',
    white: '#FFFFFF',
    sectionDivider: '#CCCCCC',
    text: {
      body: 'rgba(20, 20, 20, 1)',
      heading: 'rgba(0, 58, 120, 1)',
      link: 'rgba(0, 58, 120, 1)',
      linkDisabled: 'rgba(0, 58, 120, 0.6)'
    },
    primaryButton: {
      border: 'rgba(0, 58, 120, 1)',
      background: 'rgba(0, 58, 120, 1)',
      hover: 'rgba(0, 58, 120, 0.8)',
      disabled: 'rgba(0, 58, 120, 0.6)',
      text: '#FFFFFF',
      hoverText: '#FFFFFF',
      disabledText: '#FFFFFF'
    },
    secondaryButton: {
      border: 'rgba(99, 102, 111, 1)',
      hoverBorder: 'rgba(99, 102, 111, 0.4)',
      background: '#FFFFFF',
      hover: '#EEEEEE',
      disabled: '#F7F7F7',
      text: 'rgba(20, 20, 20, 1)',
      disabledText: 'rgba(20, 20, 20, 0.8)'
    },
    inputField: {
      background: '#EEEEEE',
      border: 'rgba(99, 102, 111, 1)',
      focusedBorder: 'rgba(0, 58, 120, 1)',
      text: 'rgba(20, 20, 20, 1)',
      placeholder: '#A6A6A6',
      disabledText: 'rgba(20, 20, 20, 0.6)'
    },
    background: {
      white: '#FFFFFF',
      light: '#F7F7F7',
      medium: '#EEEEEE',
      pageOverlay: 'rgba(85, 85, 85, 0.7)'
    }
  },
  borderRadius: {
    button: '8px',
    iconButton: '5px',
    div: '20px',
    input: '5px'
  },
  fonts: {
    heading: 'Montserrat, sans-serif',
    body: 'Montserrat, sans-serif'
  }
}
